import { useParams } from '@tanstack/react-router'
import { useRightDrawerRolodexEntries } from 'components/rightDrawer/useRightDrawerRolodexEntries'
import { useRightDrawer } from 'components/rightDrawer/utils/RightDrawerProvider'
import React from 'react'

import { UploadFile, type UploadFileProps } from './UploadFile'

type UploadFileDrawerProps = Omit<UploadFileProps, 'onClose' | 'organization'>

export const UploadFileDrawer: React.FC<UploadFileDrawerProps> = () => {
  const { siteID } = useParams({ strict: false })
  const { organization } = useRightDrawerRolodexEntries({
    siteID,
  })
  const { closeDrawer } = useRightDrawer()

  return <UploadFile organization={organization} onClose={closeDrawer} />
}
